import { render, staticRenderFns } from "./TabletOrderCreate.vue?vue&type=template&id=3bc41ceb"
import script from "./TabletOrderCreate.vue?vue&type=script&lang=js"
export * from "./TabletOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./TabletOrderCreate.vue?vue&type=style&index=0&id=3bc41ceb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports